<template>
    <div class="container">
        <form>
            <!-- <h4 v-if="notSend">ورود شماره</h4> -->
            <!-- <h4 v-else>تایید رمز</h4> -->
            
            <!-- <hr> -->
            
            <!-- PHONE NUMBER -->
            <div v-if="notSend" class="form-group" :class="{'invalid': error.number}">
                <label for="numberFeild">لطفا برای خرید دوره وارد شوید</label>
                <input 
                    v-model="number" type="number" 
                    id="numberFeild" class="form-control"
                    placeholder="شماره موبایل خود را وارد نمایید"
                >
                <div class="invalid-feedback">
                    پر کردن فیلد جاری اجباری می‌باشد
                </div>
            </div>

            <!-- CODE NUMBER -->
            <div v-else class="form-group" :class="{'invalid': error.code}">
                <!-- <label for="numberFeild">تایید رمز ارسالی</label> -->
                <input 
                    v-model="code" type="number" 
                    id="codeFeild" class="form-control"
                    placeholder="رمز ارسالی خود را وارد نمایید"
                >
                <div class="invalid-feedback">
                    پر کردن فیلد جاری اجباری می‌باشد
                </div>
            </div>

            <button
                :disabled="loading"
                v-if="notSend" type="button" 
                @click="submit" class="btn btn-success btn-center"
            >ورود</button>
            <button
                :disabled="loading"
                v-else type="button" 
                @click="check" class="btn btn-success btn-center"
            >تایید کد ارسال شده</button>

            <!--             
            <div class="form-footer">
                <span>عضو نگردیده‌اید؟</span>
                <router-link  tag="span" class="span-link" :to="{ name: 'PreRegister' }">
                    عضو شوید
                </router-link>
            </div> 
            -->
        </form>
    </div>
</template>

<script>
import { postRequest } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';
const uniqid = require('uniqid');

export default {
    name: 'Login',
    data() {
        return {
            loading: false,
            notSend: true,
            prevRoute: {},

            id: undefined,
            number: undefined,
            code: undefined,
            error: {
                number: false,
                code: false
            },
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    methods: {
        submit() {            
            this.error = {
                number: false
            }

            if (!this.number) {
                this.error.number = true; 
            }

            if (!this.error.number) {
                if(this.loading) return;
                else this.loading = true;

                postRequest('/users/send-password', { 
                    number: this.number,
                })
                    .then((rsp) => {
                        let data = rsp['data'].user || {};
                        if(!data.FirstName || !data.LastName) {
                            this.$modal.show('dialog', {
                                title: 'توجه!',
                                text: 'لطفا نام و نام خانوادگی خود را تکمیل فرمایید',
                                buttons: [
                                    {
                                        title: 'بستن',
                                        default: true,
                                    }
                                ]
                            });
                        }

                        // response
                        // this.notSend = false;
                        // this.loading = false;
                        Cookies.set('access_level', 'user')

                        // response
                        if(this.prevRoute.name == 'PreRegister') {
                            this.$router.go(-2)
                        } else if(this.prevRoute.name) {
                            this.$router.go(-1)
                        } else {
                            this.$router.push({ name: 'Khanesh' })
                        }
                    })
                    .catch((err) => {
                        // error
                        this.loading = false;
                        if(err.response) {
                            if(err.response.data.go) {
                                this.$modal.show('dialog', {
                                    title: 'خطا!',
                                    text: 'شماره جاری در سیستم موجود نمی‌باشد، آیا قصد ساخت حساب کاربری با شماره جاری را دارید؟',
                                    buttons: [
                                        {
                                            title: 'بلی',
                                            handler: () => { 
                                                this.$router.push({ name: 'PreRegister' })
                                                this.$modal.hide('dialog');
                                            }
                                        },
                                        {
                                            title: 'خیر',
                                            default: true,
                                        }
                                    ]
                                });
                            } else {
                                this.$emit('alertMsg', 
                                    { message: err.response.data.message, key: uniqid(), type: 'error' }
                                )
                            }
                        }
                    });
            }
        },
        check() {
            // LOGIN
            this.error = {
                code: false
            }

            if (!this.code) {
                this.error.code = true; 
            }

            if (!this.error.code) {
                if(this.loading) return;
                else this.loading = true;

                postRequest('/users/login', { 
                    number: this.number,
                    password: this.code
                })
                    .then(() => {
                        // response
                        this.loading = false;
                        Cookies.set('access_level', 'user')

                        // response
                        if(this.prevRoute.name) {
                            this.$router.go(-1)
                        } else {
                            this.$router.push({ name: 'Khanesh' })
                        }
                    })
                    .catch((err) => {
                        // error
                        this.loading = false;
                        if(err.response) {
                            this.$emit('alertMsg', 
                                { message: err.response.data.message, key: uniqid(), type: 'error' }
                            )
                        }
                    });
            }
        }
    }
}
</script>

<style src="@/assets/styles/Auth.css" scoped></style>